import { render } from "./widget-eotrans-ge.vue?vue&type=template&id=201c9da1"
import script from "./widget-eotrans-ge.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-eotrans-ge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/widgets/widget-eotrans-ge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "201c9da1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('201c9da1', __exports__)) {
    api.reload('201c9da1', __exports__)
  }
  
  module.hot.accept("./widget-eotrans-ge.vue?vue&type=template&id=201c9da1", () => {
    api.rerender('201c9da1', render)
  })

}


export default __exports__